export const DAILY_CHALLENGE_DAYS_COUNT = 5;
